/* eslint-disable max-len */
import { ERROR } from '../constants';

export const bulkAddCards = () => {
  const trackEvent = (event) => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push(event);
  };

  const actions = {
    totalBulkAddedCards: ({ output }) => {
      const { succesfullyAddedCards } = output || {};
      const DDOEvent = {
        category: {
          primaryCategory: 'button submission'
        },
        eventInfo: {
          eventName: 'my account settings'
        },
        myAccount: {
          settings: `cards and accounts: cards and accounts: bulk add success: ${succesfullyAddedCards}`
        }
      };
      trackEvent(DDOEvent);
    },
    pageLoaded: () => {
      const DDOEvent = {
        category: {
          primaryCategory: 'overlay'
        },
        eventInfo: {
          eventName: 'bulk add credit cards'
        },
      };
      trackEvent(DDOEvent);
    },
  };
  window.LIFE_CYCLE_EVENT_BUS.on('bulk-add-cards.actions.bulk-add-succesfully-added', actions.totalBulkAddedCards);
  window.LIFE_CYCLE_EVENT_BUS.on('bulk-add-cards.actions.bulk-add-page-loaded', actions.pageLoaded);
};
